module.exports = __webpack_public_path__ + "img/bg23.7ca7c483.png";